<h2 mat-dialog-title>{{this.data.title}}</h2>
<mat-dialog-content>
  <p>{{this.data.description}}</p>
  <mat-progress-bar mode="determinate" [color]="isSuccess() ? 'accent' : 'warn'" [value]="value()">
  </mat-progress-bar>
  <p class="message"><em>{{message()}}</em></p>
</mat-dialog-content>
